"use strict";
/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PSCSingleLineAddress$ = exports.PSCSingleLineAddress$outboundSchema = exports.PSCSingleLineAddress$inboundSchema = void 0;
exports.pscSingleLineAddressToJSON = pscSingleLineAddressToJSON;
exports.pscSingleLineAddressFromJSON = pscSingleLineAddressFromJSON;
const z = __importStar(require("zod"));
const primitives_js_1 = require("../../../lib/primitives.js");
const schemas_js_1 = require("../../../lib/schemas.js");
/** @internal */
exports.PSCSingleLineAddress$inboundSchema = z.object({
    address_line: z.nullable(z.string()),
    postcode: z.nullable(z.string()),
}).transform((v) => {
    return (0, primitives_js_1.remap)(v, {
        "address_line": "addressLine",
    });
});
/** @internal */
exports.PSCSingleLineAddress$outboundSchema = z.object({
    addressLine: z.nullable(z.string()),
    postcode: z.nullable(z.string()),
}).transform((v) => {
    return (0, primitives_js_1.remap)(v, {
        addressLine: "address_line",
    });
});
/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
var PSCSingleLineAddress$;
(function (PSCSingleLineAddress$) {
    /** @deprecated use `PSCSingleLineAddress$inboundSchema` instead. */
    PSCSingleLineAddress$.inboundSchema = exports.PSCSingleLineAddress$inboundSchema;
    /** @deprecated use `PSCSingleLineAddress$outboundSchema` instead. */
    PSCSingleLineAddress$.outboundSchema = exports.PSCSingleLineAddress$outboundSchema;
})(PSCSingleLineAddress$ || (exports.PSCSingleLineAddress$ = PSCSingleLineAddress$ = {}));
function pscSingleLineAddressToJSON(pscSingleLineAddress) {
    return JSON.stringify(exports.PSCSingleLineAddress$outboundSchema.parse(pscSingleLineAddress));
}
function pscSingleLineAddressFromJSON(jsonString) {
    return (0, schemas_js_1.safeParse)(jsonString, (x) => exports.PSCSingleLineAddress$inboundSchema.parse(JSON.parse(x)), `Failed to parse 'PSCSingleLineAddress' from JSON`);
}
//# sourceMappingURL=pscsinglelineaddress.js.map